// extracted by mini-css-extract-plugin
module.exports = {"cls1":"StyledComponents-LoadingText_cls1__VbG_x","cls2":"StyledComponents-LoadingText_cls2__v9-Wp StyledComponents-LoadingText_cls1__VbG_x"};